var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillOpacity: 0.4,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#757B83"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M15.29 2.12L18.17 5H5c-.55 0-1 .45-1 1s.45 1 1 1h13.17l-2.88 2.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L16.7.7c-.39-.39-1.02-.39-1.41 0-.38.39-.39 1.03 0 1.42zM23 1v10c0 .55.45 1 1 1s1-.45 1-1V1c0-.55-.45-1-1-1s-1 .45-1 1z",
    transform: "translate(-12 -28) translate(11 28)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 8,
    fontWeight: 500,
    transform: "translate(-12 -28) translate(11 28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.949,
    y: 24
  }, "MENU")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMenu);
export default __webpack_public_path__ + "static/media/icons-menu.1508e2860a38d5c2c65847f78eee6058.svg";
export { ForwardRef as ReactComponent };